import { Component, Input, ViewChild } from '@angular/core';
import { ProvidersService } from 'fccore2'; 
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToolbarFormAction } from '../fctlb/fctlbform.component';
import { FcinputComponent } from '../fcinput';
import { FcmodallistComponent } from '../fcmodal/fcmodallist.component'; 
import { FCEVENT } from '../fc';
import { CommonService } from 'fccore2';
import { SysappfieldDic, Sysappbuttons, Sysappfields } from 'fccore2';
import { ResponseResult } from 'fccore2';
@Component({
    selector: 'fc-adform',
    template: `
    <fc-layoutpanel class="fc-adform" *ngIf="fcOption.fcValidate!==undefined">
        <fc-title [fcLabel]="fcOption.fcTitle" fcheader></fc-title>
        <div fccontent>
            <form nz-form [nzLayout]="fcOption.fcLayout" [formGroup]="fcOption.fcValidate">
                <nz-row [nzGutter]="4">
                    <nz-form-item nz-col [nzSpan]="fcOption.fcSpans" *ngFor="let field of fcOption.fcFields">
                           <nz-form-label [nzSm]="8" [nzXs]="24">{{field.FIELDNAME}}</nz-form-label>
                            <nz-form-control [nzSm]="16" [nzXs]="24" nzHasFeedback>
                                <fc-text [formControlName]="field.FIELDCODE" fcShowLabel="Y" [fcForId]="field.APPID+field.FIELDCODE" *ngIf="field.DBTYPE==='STR'&&field.INPUTTYPE==='text'"></fc-text>
                                <fc-double [formControlName]="field.FIELDCODE" fcShowLabel="Y" [fcForId]="field.APPID+field.FIELDCODE" *ngIf="field.DBTYPE==='NUM'&&field.SCALE!=='0'"></fc-double>
                                <fc-long [formControlName]="field.FIELDCODE" fcShowLabel="Y" [fcForId]="field.APPID+field.FIELDCODE" *ngIf="field.DBTYPE==='NUM'&&field.SCALE==='0'"></fc-long>
                                <fc-radio [formControlName]="field.FIELDCODE" fcShowLabel="Y" [fcForId]="field.APPID+field.FIELDCODE" *ngIf="field.INPUTTYPE==='radio'&&fcOption.fcFieldDics[field.FIELDCODE].DICTYPE==='LISTVALUE'" [fcOption]="fcOption.fcFieldDics[field.FIELDCODE].SYSAPPDICDETAIL" fcValueCode="DICVALUE" fcLabelCode="DICDESC"></fc-radio>
                                <fc-check [formControlName]="field.FIELDCODE" fcShowLabel="Y" [fcForId]="field.APPID+field.FIELDCODE" *ngIf="field.INPUTTYPE==='check'&&fcOption.fcFieldDics[field.FIELDCODE].DICTYPE==='LISTVALUE'" [fcOption]="fcOption.fcFieldDics[field.FIELDCODE].SYSAPPDICDETAIL" fcValueCode="DICVALUE" fcLabelCode="DICDESC"></fc-check>
                                <fc-combo [formControlName]="field.FIELDCODE" fcShowLabel="Y" [fcForId]="field.APPID+field.FIELDCODE" *ngIf="field.INPUTTYPE==='combo'&&fcOption.fcFieldDics[field.FIELDCODE].DICTYPE==='LISTVALUE'" [fcOption]="fcOption.fcFieldDics[field.FIELDCODE].SYSAPPDICDETAIL" fcValueCode="DICVALUE" fcLabelCode="DICDESC"></fc-combo>
                                <fc-chosen [formControlName]="field.FIELDCODE" fcShowLabel="Y" [fcForId]="field.APPID+field.FIELDCODE" *ngIf="field.INPUTTYPE==='chosen'&&fcOption.fcFieldDics[field.FIELDCODE].DICTYPE==='LISTVALUE'" [fcOption]="fcOption.fcFieldDics[field.FIELDCODE].SYSAPPDICDETAIL" fcValueCode="DICVALUE" fcLabelCode="DICDESC"></fc-chosen>
                                <fc-text [formControlName]="field.FIELDCODE" fcShowLabel="Y" [fcAddOnAfter]="'anticon anticon-search'" [fcForId]="field.APPID+field.FIELDCODE" *ngIf="field.DBTYPE==='STR'&&field.INPUTTYPE.indexOf('queryselect')!==-1" (fcEvent)="_search($event,field,fcOption.fcFieldDics[field.FIELDCODE].SYSAPPDICAPP)"></fc-text>
                                <fc-textarea [formControlName]="field.FIELDCODE" fcShowLabel="Y" [fcForId]="field.APPID+field.FIELDCODE" *ngIf="field.INPUTTYPE==='textarea'"></fc-textarea>
                                <nz-form-explain *ngIf="_getFormControl(field.FIELDCODE).dirty&&_getFormControl(field.FIELDCODE).hasError('required')">æ ¡éªå¼å¸¸ï¼å¿å¡«é¡¹}}!</nz-form-explain>
                                <nz-form-explain *ngIf="_getFormControl(field.FIELDCODE).dirty&&_getFormControl(field.FIELDCODE).hasError('maxlength')">æ ¡éªå¼å¸¸ï¼è¶åºæå¤§é¿åº¦,æå¤§é¿åº¦ä¸º{{field.LENGTH}}!</nz-form-explain>
                            </nz-form-control>
                    </nz-form-item>
                </nz-row>
                <nz-form-item>
                    <fc-tlbform [fcButtons]="fcOption.fcToolbar" (fcEvent)="_event($event)"></fc-tlbform>
                    <fc-modallist #FcadformComponent [fcTitle]="_modalOption.fcTitle" [fcCondition]="_modalOption.fcCondition" [fcAppid]="_modalOption.fcAppid" [fcType]="_modalOption.fcType" (fcEvent)="_modalClose($event)"></fc-modallist>
                </nz-form-item>
            </form>
        </div>
    </fc-layoutpanel>
    `,
    styles: [`
    .fc-adfform{
        width:100%;
        height:100%;
    }
    .fc-adfform-label {
        display:block;
        padding-right:10px;
        text-align:right;
    }
    :host ::ng-deep .ant-select-dropdown-menu-item{
        overflow: visible;
    }
    `]
})
export class FcadformComponent extends FcinputComponent {
    @ViewChild('FcadformComponent', {static: false})
    modalList: FcmodallistComponent;
     /** å­æ®µå*/
    @Input()
    fcOption: FcadformOption;
    _modalOption: FcformmodalOption;
    private _tempCopyInfo: any = {};
    constructor(public provider: ProvidersService, private fb: FormBuilder) {
        super(provider, 'fc-adform');
        this._modalOption = { fcAppid: '', fcTitle: '', fcType: '', fcCondition: '{}' }
    }
    _search(event: any, field: any, dicApps: any[]) {
        let dicApp = dicApps[0];
        this._tempCopyInfo.DICAPP = dicApp;
        this._tempCopyInfo.FIELD = field;
        this._modalOption.fcAppid = dicApp.APPID;
        this._modalOption.fcTitle = 'è¯·éæ©' + field.FIELDNAME;
        if (field.INPUTTYPE === 'queryselectmutiple') {
            this._modalOption.fcType = 'mutiple';
        } else {
            this._modalOption.fcType = 'sinple';
        }
        if (dicApp.APPFILTER !== undefined && dicApp.APPFILTER !== '' && dicApp.APPFILTER !== 'null') {
            let str = dicApp.APPFILTER.trim();
            let condition = str.toUpperCase().indexOf('AND') !== -1 ? str.substr(3, str.length) : str;
            this._modalOption.fcCondition = '{"WHERE":"' + CommonService.getStringFilterByParam(this.fcOption.fcValidate.value, condition) + '"}';
        }
        this.modalList.fcAppid = dicApp.APPID;
        this.modalList.fcTitle = this._modalOption.fcTitle;
        this.modalList.fcCondition = this._modalOption.fcCondition;
        this.modalList.fcType = this._modalOption.fcType;
        this.modalList.showModal();
    }
    _modalClose(event: FCEVENT) {
        if (event.eventName === 'success') {
            let value = "";
            if (event.param) {
                event.param.forEach(item => {
                    value += item[this._tempCopyInfo.DICAPP.FIELDCODE] + ",";
                });
                if (value !== '') {
                    value = value.substr(0, value.length - 1);
                }
                this.fcOption.fcValidate.controls[this._tempCopyInfo.FIELD.FIELDCODE].setValue(value);
            }
        }
    }
    /**
     * ç¶çº§åå§åå®æåæ§è¡æ¹æ³
     */
    _afterParentInit() {
        if (!this.fcOption.hasOwnProperty('fcLayout') || this.fcOption.fcLayout === undefined) {
            this.fcOption.fcLayout = FORMLAYOUT.HORIZONTAL;
        }
        if (!this.fcOption.hasOwnProperty('fcTitle') || this.fcOption.fcTitle === undefined) {
            this.fcOption.fcTitle = this.fcApp.APPNAME;
        }
        if (!this.fcOption.hasOwnProperty('fcFields') || this.fcOption.fcFields === undefined) {
            this.fcOption.fcFields = this.fcApp.SYSAPPFIELDS.filter(item => item.SHOWCARD === 'Y');
        }
         /**åå§åfields*/
        let validateForm: any = {};
        this.fcOption.fcFields.forEach(field => {
            let value = null;
            let validators = [Validators.maxLength(field.LENGTH)];
            if (this.fcMainObj !== undefined) {
                value = this.fcMainObj[field.FIELDCODE];
            }
            if (field.ISNULL === 'Y') {
                validators.push(Validators.required);
            }
            validateForm[field.FIELDCODE] = [value, validators];
        });
        this.fcOption.fcValidate = this.fb.group(validateForm);

        if (!this.fcOption.hasOwnProperty('fcFieldDics') || this.fcOption.fcFieldDics === undefined) {
            this.fcOption.fcFieldDics = {};
            this.fcOption.fcFields.filter(field => field.DICCODE !== undefined && field.DICCODE !== null && field.DICCODE !== '')
                .forEach(item => {
                    const fieldDic: SysappfieldDic = {};
                    const dicList = this.fcApp.SYSDIC.filter(dic => dic.DICID === item.DICCODE);
                    if (dicList.length !== 0) {
                        fieldDic.DICID = dicList[0].DICID;
                        fieldDic.DICTYPE = dicList[0].DICTYPE;
                        fieldDic.FIELDCODE = item.FIELDCODE;
                        if (fieldDic.DICTYPE === 'LISTAPP') {
                            fieldDic.SYSDICAPP = dicList[0].SYSDICAPP;
                        } else {
                            fieldDic.SYSDICDETAIL = dicList[0].SYSDICDETAIL;
                        }
                    }
                    this.fcOption.fcFieldDics[item.FIELDCODE] = fieldDic;
                });
        }
        if (!this.fcOption.hasOwnProperty('fcToolbar') || this.fcOption.fcToolbar === undefined) {
            this.fcOption.fcToolbar = this.fcApp.SYSAPPBUTTONS.filter(item => item.BTNTYPE === 'CARD');
        }
        if (!this.fcOption.hasOwnProperty('fcSpans') || this.fcOption.fcSpans === undefined) {
            this.fcOption.fcSpans = 24 / this.fcApp.CARDCOLS;
        }
    }
    /**
    * åé
    */
    private _back($event: Sysappbuttons): void {
        this.event( $event.ACTCODE,
            $event);
    }
    /**
     * 
     * @param  äºä»¶æé®
     */
    _event($event: FCEVENT) {
        let event: Sysappbuttons = $event.param;
        switch (event.ACTCODE) {
            case ToolbarFormAction.NEXT:
                this._next();
                break;
            case ToolbarFormAction.PREV:
                this._prev();
                break;
            case ToolbarFormAction.CARDBACK:
                this._back(event);
                break;
            case ToolbarFormAction.CARDNEW:
                this.fcMainObj = this.appService.initObjDefaultValue(this.fcApp);
                this.fcMainObj.ID = '';
                this.fcId = this.fcMainObj.ID;
                this.fcOption.fcValidate.patchValue(this.fcMainObj);
                break;
            case ToolbarFormAction.CARDSAVE:
            case ToolbarFormAction.CARDSAVECOPY:
            case ToolbarFormAction.CARDSAVENEW:
            case ToolbarFormAction.CARDSAVEBACK:
                this._doAct(event);
                break;
            default:
                this.event(event.ACTCODE,
                     event
                );
        }
    }
    private _doAct($event: any) {
        Object.keys(this.fcOption.fcValidate.value).forEach(key => {
            this.fcMainObj[key] = this.fcOption.fcValidate.value[key];
        });
        if (this.fcMainObj.ID !== undefined && this.fcMainObj.ID !== '') {
            this.pushDestroy(this.appService.updateObject(this.fcApp.APPID, this.fcMainObj).subscribe(result => {
                this._afterAct($event, result);
            }));
        } else {
            this.pushDestroy(this.appService.saveObject(this.fcApp.APPID, this.fcMainObj).subscribe(result => {
                this._afterAct($event, result);
            }));
        }
    }
    _afterAct($event: Sysappbuttons, result: ResponseResult) {
        if (result.CODE === '0') {
            this.event( "AFTERSAVE", result.DATA[0]);
            switch ($event.ACTCODE) {
                case ToolbarFormAction.CARDSAVE:
                    this.fcMainObj = result.DATA[0];
                    this.fcId = this.fcMainObj.ID;
                    this.fcOption.fcValidate.patchValue(this.fcMainObj);
                    break;
                case ToolbarFormAction.CARDSAVECOPY:
                    this.fcMainObj = result.DATA[0];
                    this.fcMainObj.ID = '';
                    this.fcId = this.fcMainObj.ID;
                    this.fcOption.fcValidate.patchValue(this.fcMainObj);
                    break;
                case ToolbarFormAction.CARDSAVENEW:
                    this.fcMainObj = this.appService.initObjDefaultValue(this.fcApp);
                    this.fcMainObj.ID = '';
                    this.fcId = this.fcMainObj.ID;
                    this.fcOption.fcValidate.patchValue(this.fcMainObj);
                    break;
                case ToolbarFormAction.CARDSAVEBACK:
                    this._back($event);
                    break;
            }
            this.msgService.message(result.MSG);
        } else {
            this.msgService.error(result.MSG);
        }
    }
    /**
     * ä¸ä¸æ¡
     */
    private _next(): void {
        this.event( "next", this.fcMainObj);
    };
    /**
     *  ä¸ä¸æ¡
     */
    private _prev(): void {
        this.event( "prev",this.fcMainObj);
    };

    _getFormControl(name): any {
        return this.fcOption.fcValidate.controls[name];
    }

}
export interface FcadformOption {
    /** è¡¨åæ é¢ */
    fcTitle?: string;
    /** è¡¨åå¯æ é¢ */
    fcSubTitle?: string;
    fcFields?: Sysappfields[];
    /** è¡¨åéç½® */
    fcToolbar?: Sysappbuttons[];
    fcFieldDics?: any;
    fcAct?: FORMACTION;
    fcLayout?: string;
    fcValidate?: FormGroup;
    /** ååæ° */
    fcSpans?: number;
}
export interface FcformmodalOption {
    fcAppid: string;
    fcTitle: string;
    fcType: string;
    fcCondition: string;
}
export enum FORMACTION {/**æ°å¢*/ADD, /**ä¿®æ¹*/MODIFY };
export const FORMLAYOUT = { INLINE: 'inline', HORIZONTAL: 'horizontal', VERTICAL: "vertical" };